/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';
import CopyPermalinkButton from 'shared/ui/components/listings/custom-actions/CopyPermalinkButton.vue';
import ListExportModal from 'shared/ui/components/modals/ListExportModal.vue';

// Constants
const MINIMUM_SEARCH_LENGTH = 3;

const __vue_script__ = {
    name: 'AccreditedLinks',

    components: { SearchBar, CopyPermalinkButton, ListExportModal },

    props: {
        params: {
            type: Object,
            required: true
        },

        testing: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            error: null,
            searchTerm: '',
            links: [],
            selectedItems: [],
            eventId: this.params.event.id,
            searchableTerms: ['id', 'name', 'created_by.email', 'created_by.fullname']
        };
    },

    computed: {
        /** @returns {AccreditedLink[]} */
        activeLinks() {
            return this.links.filter(l => !l.revoked);
        },

        /** @returns {boolean} */
        allSelected() {
            return this.activeLinks.length !== 0 && this.activeLinks.length === this.selectedItems.length;
        },

        /** @returns {String[]} */
        selectedItemsId() {
            return this.selectedItems.map(item => item.id);
        },

        /** @returns {AccreditedLink[]} */
        visibleLinks() {
            const search = this.searchTerm.trim().toLocaleLowerCase();
            if (!search.length || search.length <= MINIMUM_SEARCH_LENGTH) {
                return this.links;
            } else {
                return this.links
                    .filter(link => {
                        const lookup = this.searchableTerms
                            .map(term => get(link, term, '').toLocaleLowerCase())
                            .join(' ');
                        return lookup.includes(search);
                    });
            }
        }
    },

    watch: {
        selectedItems() {
            /** @type {HTMLInputElement} */
            const bulkSelector = this.$refs.bulkToggler || {};
            bulkSelector.indeterminate = this.selectedItems.length && !this.allSelected;
        }
    },

    created() {
        this.initAndLoadLinks();
    },

    methods: {
        /**
         * (Re)initialize the component with needed data
         */
        async initAndLoadLinks() {
            try {
                this.searchTerm = '';
                this.selectedItems = [];
                this.links = await this.$services.deepLink.getAll(this.eventId);

                this.links.forEach(link => {
                    link.name = link.name || this.$i18n.t('accredited_links.defaults.name');
                });

            } catch (error) {
                console.error('[AccreditedLink] Could not load accredited links', error.message);
                this.error = error;
            }
        },

        /**
         * Selects or unselects all the items.
         * @param {boolean} [forceUnselect=false] whether to force to unselect all or not
         */
        toggleAll(forceUnselect = false) {
            if (this.allSelected || forceUnselect) {
                this.selectedItems = [];
            } else {
                this.selectedItems = [...this.activeLinks];
            }
        },

        /**
         * Toggles the specified item.
         *
         * @param {Object} item the item to select
         */
        toggleItem(item) {
            if (item.revoked) {
                return;
            }

            const index = this.selectedItems.indexOf(item);
            if (index === -1) {
                this.selectedItems.push(item);
            } else {
                this.selectedItems.splice(index, 1);
            }
        },

        /**
         * Prompts the user before revoking the links
         *
         * @param {AccreditedLink[]} links the links to remove
         */
        promptRevoke(links) {
            if (links.length === 1) {
                this.toggleAll(true);
                this.toggleItem(links[0]);
            }

            this.$modal.show('dialog', {
                title: this.$i18n.t('general.warning'),
                text: this.$i18n.tc('accredited_links.messages.revoke_prompt', links.length, [links.length]),
                buttons: [
                    {
                        title: this.$i18n.t('general.cancel'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$i18n.t('accredited_links.actions.revoke'),
                        handler: () => {
                            this.revoke(links);
                            this.$modal.hide('dialog');
                        },
                        class: 'btn btn-danger'
                    }
                ]
            });
        },

        /**
         * Revokes accredited links
         *
         * @param {AccreditedLink[]} links the link to revoke
         */
        async revoke(links) {
            try {
                await this.$services.deepLink.revoke(this.eventId, links);
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.tc('accredited_links.messages.links_revoked', links.length).toString(),
                    type: 'success'
                });
            } catch (error) {
                console.error('[AccreditedLink] Could not revoke the link(s)', error.message);
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.tc('accredited_links.messages.links_revoke_error', links.length).toString(),
                    type: 'error'
                });
            } finally {
                this.initAndLoadLinks();
            }
        },

        /**
         * Opens the export modal
         */
        openExportModal() {
            this.$modal.show(ListExportModal, {
                title: 'Permalinks',
                fpType: 'accredited_link',
                exporter: '',
                event: this.params.event
            }, {
                classes: 'small',
                height: 'auto',
                clickToClose: false
            });
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accredited-links"},[(_vm.error)?[_c('div',{staticClass:"alert alert-error"},[_c('h2',[_vm._v(_vm._s(_vm.$t('general.error_occurred')))]),_c('p',[_vm._v(_vm._s(_vm.$t('general.try_later')))])])]:[_c('div',{staticClass:"listing-actions"},[_c('div',{staticClass:"action-buttons"},[(_vm.selectedItems.length > 0)?_c('a',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.promptRevoke(_vm.selectedItems)}}},[_vm._v(_vm._s(_vm.$t('accredited_links.actions.revoke')))]):_c('a',{staticClass:"btn",on:{"click":function($event){return _vm.openExportModal()}}},[_vm._v(_vm._s(_vm.$t('listings.actions.export_xls')))])]),_c('search-bar',{attrs:{"show-no-result":false},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})],1),_c('div',{staticClass:"table-wrapper"},[_c('table',{staticClass:"table-striped actionable"},[_c('thead',[_c('tr',[_c('th',{staticClass:"selector"},[_c('input',{ref:"bulkToggler",attrs:{"type":"checkbox"},domProps:{"checked":_vm.allSelected},on:{"change":function($event){return _vm.toggleAll()}}})]),_c('th',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('accredited_links.list.title')))]),_c('th',{staticClass:"author"},[_vm._v(_vm._s(_vm.$t('accredited_links.list.created_by')))]),_c('th',{staticClass:"created"},[_vm._v(_vm._s(_vm.$t('accredited_links.list.created_at')))]),_c('th',{staticClass:"copy"},[_vm._v(_vm._s(_vm.$t('accredited_links.list.copy_permalink')))]),_c('th',{staticClass:"actions"})])]),_c('tbody',_vm._l((_vm.visibleLinks),function(link){return _c('tr',{class:{ selected: _vm.selectedItemsId.includes(link.id), invalid: link.revoked },on:{"click":function($event){return _vm.toggleItem(link)}}},[_c('td',{staticClass:"selector"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedItemsId),expression:"selectedItemsId"}],attrs:{"type":"checkbox","disabled":link.revoked},domProps:{"value":link.id,"checked":Array.isArray(_vm.selectedItemsId)?_vm._i(_vm.selectedItemsId,link.id)>-1:(_vm.selectedItemsId)},on:{"change":function($event){var $$a=_vm.selectedItemsId,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=link.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedItemsId=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedItemsId=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedItemsId=$$c}}}})]),_c('td',{staticClass:"title"},[_c('strong',[_c('a',{attrs:{"href":link.url,"target":"_blank","rel":"noopener noreferrer"},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(_vm._s(link.name))])])]),_c('td',{staticClass:"author"},[(link.created_by)?[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(link.created_by.email),expression:"link.created_by.email"}]},[_vm._v(_vm._s(link.created_by.fullname))])]:[_vm._v(_vm._s(_vm.$t('accredited_links.defaults.created_by')))]],2),_c('td',{staticClass:"created"},[(link.created_at)?[_vm._v(_vm._s(_vm.$utils.time.tsToFormat(link.created_at)))]:[_vm._v(_vm._s(_vm.$t('accredited_links.defaults.created_at')))]],2),_c('td',{staticClass:"copy"},[(!link.revoked)?_c('copy-permalink-button',{attrs:{"name":link.name,"event":_vm.params.event,"link-url":link.short_url || link.url,"label":link.short_url || link.url}}):_vm._e()],1),_c('td',{staticClass:"actions"},[(link.revoked)?[_vm._v(_vm._s(_vm.$t('accredited_links.list.revoked_at', [_vm.$utils.time.tsToFormat(link.revoked_at)])))]:[_c('a',{staticClass:"btn btn-danger",on:{"click":function($event){$event.stopPropagation();return _vm.promptRevoke([link])}}},[_vm._v(_vm._s(_vm.$t('accredited_links.actions.revoke')))])]],2)])}),0)])])],(_vm.testing)?_c('v-dialog'):_vm._e()],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "AccreditedLinks.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__